
import { BoxTopMenu } from "./top-menu.box";
import { CloudTopMenu } from "./top-menu.cloud";
import { DemoTopMenu } from "./top-menu.demo";
import { mixin } from "@cems-eco/core/src/utils/platform";
import environment from "@/config";

export default class TopMenu extends mixin(environment.nexus, {
  box: BoxTopMenu,
  cloud: CloudTopMenu,
  demo: DemoTopMenu,
}) {
  [key: string]: any;
}
